import { useState } from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import type { ColDef, RowClickedEvent } from 'ag-grid-community';
import { useNavigate, useOutletContext } from 'react-router';
import { DataGrid } from '../../../components/data-grid';
import type { PlantDetailQuery } from '../../../gql/graphql';

type PlantDetail = NonNullable<PlantDetailQuery['plantDetail']>;
type PlantAssetRow = PlantDetail['assets'][number];

const columns: ColDef<PlantAssetRow>[] = [
  { field: 'assetCode', headerName: 'Asset Code', flex: 1 },
  { field: 'sapOrderNumber', headerName: 'SAP Order Number', flex: 1 },
  { field: 'serialNumber', headerName: 'Serial Number', flex: 1 },
  { field: 'brandName', headerName: 'Brand', flex: 1 },
  { field: 'modelName', headerName: 'Model', flex: 1 },
  { field: 'formOfFinanceName', headerName: 'Form of Finance', flex: 1 },
  { field: 'status', headerName: 'Status', flex: 1 },
  { field: 'readingDate', headerName: 'Clock Reading Date', flex: 1 },
  { field: 'smr', headerName: 'SMR', flex: 1 },
  { field: 'runtime', headerName: 'Runtime', flex: 1 },
  { field: 'fuel', headerName: 'Fuel', flex: 1 },
  { field: 'consumption', headerName: 'Consumption', flex: 1 },
];

export function PlantAssetsTab() {
  const plant = useOutletContext<PlantDetail>();
  const navigate = useNavigate();
  const [showArchived, setShowArchived] = useState(false);
  const assets = plant.assets.filter((asset) => asset.isArchived === showArchived);

  const onRowClicked = (event: RowClickedEvent<PlantAssetRow>) => {
    if (event.data) navigate(`/assets/${event.data.id}`);
  };

  return (
    <section className="py-6" data-testid="plant-assets-tab">
      <FormControlLabel
        control={<Checkbox checked={showArchived} onChange={(event) => setShowArchived(event.target.checked)} />}
        label="Archived Assets"
      />
      <DataGrid<PlantAssetRow> rowData={assets} columnDefs={columns} onRowClicked={onRowClicked} height="65vh" />
    </section>
  );
}